import React, { lazy, Suspense, useContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loadable from "../Loader/Loadable";
import Loader from "../Loader/Loader";
import { AuthContextProvider } from "../AuthContext/AuthContextProvider";

const AddUpdateProposal = Loadable(
  lazy(() => import("../Pages/AddUpdateProposal"))
);
const GenerateContract = Loadable(
  lazy(() => import("../Component/GenerateContract"))
);
const AcceptProposal = Loadable(
  lazy(() => import("../Component/AcceptDeclineProposal"))
);
function Index() {
  const { loader } = useContext(AuthContextProvider);
  return (
    <div id="layout-wrapper">
      <Suspense>
        <BrowserRouter>
          {loader && <Loader />}
          <Routes>
            <Route path="*" element={<AddUpdateProposal />} />
            <Route
              path="/generate-contract"
              element={<GenerateContract />}
            />
            <Route
              path="/accept-decline-proposal"
              element={<AcceptProposal />}
            />
            {/* <Route path="/GetQuote" element={<AddUpdateProposal />} /> */}
          </Routes>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default Index;
